var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "errorManagerModal",
        size: "xl",
        "content-class": "menu-bg-blue-transparent-modal",
        title: "Delivery Review Tool Error Manager",
        scrollable: "",
        "hide-footer": "",
      },
    },
    [
      _c("vue-bootstrap4-table", {
        attrs: {
          columns: _vm.columns,
          config: _vm.config,
          classes: _vm.classes,
          rows: _vm.rows,
        },
        scopedSlots: _vm._u([
          {
            key: "id",
            fn: function (props) {
              return [
                _c(
                  "div",
                  {
                    on: {
                      dblclick: function ($event) {
                        return _vm.zoomToError(props.row.x, props.row.y)
                      },
                    },
                  },
                  [_vm._v("\n        " + _vm._s(props.cell_value) + "\n      ")]
                ),
              ]
            },
          },
          {
            key: "comments",
            fn: function (props) {
              return [
                _c(
                  "div",
                  {
                    on: {
                      dblclick: function ($event) {
                        return _vm.zoomToError(props.row.x, props.row.y)
                      },
                    },
                  },
                  [_vm._v("\n        " + _vm._s(props.cell_value) + "\n      ")]
                ),
              ]
            },
          },
          {
            key: "layer",
            fn: function (props) {
              return [
                _c(
                  "div",
                  {
                    on: {
                      dblclick: function ($event) {
                        return _vm.zoomToError(props.row.x, props.row.y)
                      },
                    },
                  },
                  [_vm._v("\n        " + _vm._s(props.cell_value) + "\n      ")]
                ),
              ]
            },
          },
          {
            key: "dataset",
            fn: function (props) {
              return [
                _c(
                  "div",
                  {
                    on: {
                      dblclick: function ($event) {
                        return _vm.zoomToError(props.row.x, props.row.y)
                      },
                    },
                  },
                  [_vm._v("\n        " + _vm._s(props.cell_value) + "\n      ")]
                ),
              ]
            },
          },
          {
            key: "status",
            fn: function (props) {
              return [
                _c(
                  "div",
                  {
                    on: {
                      dblclick: function ($event) {
                        return _vm.zoomToError(props.row.x, props.row.y)
                      },
                    },
                  },
                  [_vm._v("\n        " + _vm._s(props.cell_value) + "\n      ")]
                ),
              ]
            },
          },
          {
            key: "severity",
            fn: function (props) {
              return [
                _c(
                  "div",
                  {
                    on: {
                      dblclick: function ($event) {
                        return _vm.zoomToError(props.row.x, props.row.y)
                      },
                    },
                  },
                  [_vm._v("\n        " + _vm._s(props.cell_value) + "\n      ")]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }